"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrow__factory = void 0;
var _ethers = require("ethers");
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* Autogenerated file. Do not edit manually. */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "CallerNotBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "CallerNotHolder",
  type: "error"
}, {
  inputs: [],
  name: "DualRoleRejectionRequired",
  type: "error"
}, {
  inputs: [],
  name: "EmptyReceivingData",
  type: "error"
}, {
  inputs: [],
  name: "InactiveTitleEscrow",
  type: "error"
}, {
  inputs: [],
  name: "InvalidInitialization",
  type: "error"
}, {
  inputs: [],
  name: "InvalidNominee",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "registry",
    type: "address"
  }],
  name: "InvalidRegistry",
  type: "error"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }],
  name: "InvalidTokenTransferToZeroAddressOwners",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTransferToZeroAddress",
  type: "error"
}, {
  inputs: [],
  name: "NomineeAlreadyNominated",
  type: "error"
}, {
  inputs: [],
  name: "NotInitializing",
  type: "error"
}, {
  inputs: [],
  name: "RecipientAlreadyHolder",
  type: "error"
}, {
  inputs: [],
  name: "RegistryContractPaused",
  type: "error"
}, {
  inputs: [],
  name: "RemarkLengthExceeded",
  type: "error"
}, {
  inputs: [],
  name: "TargetNomineeAlreadyBeneficiary",
  type: "error"
}, {
  inputs: [],
  name: "TitleEscrowNotHoldingToken",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotReturnedToIssuer",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "BeneficiaryTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "HolderTransfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "uint64",
    name: "version",
    type: "uint64"
  }],
  name: "Initialized",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "prevNominee",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "nominee",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "Nomination",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "RejectTransferBeneficiary",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "RejectTransferHolder",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "fromBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "toBeneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "fromHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "toHolder",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "RejectTransferOwners",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "caller",
    type: "address"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "ReturnToIssuer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "Shred",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    indexed: true,
    internalType: "bool",
    name: "isMinting",
    type: "bool"
  }, {
    indexed: false,
    internalType: "address",
    name: "registry",
    type: "address"
  }, {
    indexed: false,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }, {
    indexed: false,
    internalType: "bytes",
    name: "remark",
    type: "bytes"
  }],
  name: "TokenReceived",
  type: "event"
}, {
  inputs: [],
  name: "active",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "beneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "holder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_registry",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }],
  name: "initialize",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "isHoldingToken",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "nominate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "nominee",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "_tokenId",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "prevBeneficiary",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "prevHolder",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "registry",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "rejectTransferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "rejectTransferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "rejectTransferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "remark",
  outputs: [{
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "returnToIssuer",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "shred",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "tokenId",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "transferBeneficiary",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "newHolder",
    type: "address"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "transferHolder",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_nominee",
    type: "address"
  }, {
    internalType: "address",
    name: "newHolder",
    type: "address"
  }, {
    internalType: "bytes",
    name: "_remark",
    type: "bytes"
  }],
  name: "transferOwners",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";
const isSuperArgs = xs => xs.length > 1;
class TitleEscrow__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }
  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }
  deploy(overrides) {
    return super.deploy(overrides || {});
  }
  connect(runner) {
    return super.connect(runner);
  }
  static createInterface() {
    return new _ethers.Interface(_abi);
  }
  static connect(address, runner) {
    return new _ethers.Contract(address, _abi, runner);
  }
}
exports.TitleEscrow__factory = TitleEscrow__factory;
_defineProperty(TitleEscrow__factory, "bytecode", _bytecode);
_defineProperty(TitleEscrow__factory, "abi", _abi);